import * as Icons from "lucide-react";
import { SECTION_META, STATUS_META } from "./reviewMeta";
import { StatusDot } from "./StatusDot";

// Soft, non-blocking approval guardrail.
// incompleteRequired = string[] section keys; statusOf = (key) => status
// actions via: onClose, onReturn, onApprove
export function ApprovalGuardrailDialog({ incompleteRequired, statusOf, onClose, onReturn, onApprove }) {
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4" data-testid="ca-approve-confirm">
      <div className="absolute inset-0 bg-slate-900/50" onClick={onClose} />
      <div className="relative bg-white rounded-2xl shadow-xl max-w-md w-full p-6" role="dialog" aria-modal="true" aria-labelledby="ca-approve-confirm-title">
        <div className="flex items-start gap-3 mb-3">
          <span className="inline-flex items-center justify-center h-9 w-9 rounded-full bg-amber-50 text-amber-600 shrink-0"><Icons.AlertTriangle className="h-5 w-5" /></span>
          <div>
            <h3 id="ca-approve-confirm-title" className="text-base font-bold text-slate-900">Some review sections are not complete</h3>
            <p className="text-sm text-slate-500 mt-0.5">The following sections have not been fully reviewed:</p>
          </div>
        </div>
        <ul className="space-y-1.5 mb-4 pl-1" data-testid="ca-approve-confirm-list">
          {incompleteRequired.map((k) => (
            <li key={k} className="flex items-center gap-2 text-sm">
              <StatusDot status={statusOf(k)} size="h-3.5 w-3.5" />
              <span className="font-medium text-slate-800">{SECTION_META[k].label}</span>
              <span className="text-slate-400">— {STATUS_META[statusOf(k)].label}</span>
            </li>
          ))}
        </ul>
        <p className="text-sm text-slate-500 mb-5">Approving now will create and send the estimate using the current information.</p>
        <div className="flex items-center justify-end gap-2">
          <button onClick={onReturn} data-testid="ca-approve-return"
            className="inline-flex items-center gap-1.5 rounded-lg border border-slate-200 text-slate-700 hover:bg-slate-50 px-4 py-2 text-sm font-semibold"><Icons.ArrowLeft className="h-4 w-4" />Return to Review</button>
          <button onClick={onApprove} data-testid="ca-approve-anyway"
            className="inline-flex items-center gap-1.5 rounded-lg bg-emerald-600 hover:bg-emerald-700 text-white px-4 py-2 text-sm font-semibold"><Icons.CheckCircle2 className="h-4 w-4" />Approve Anyway</button>
        </div>
      </div>
    </div>
  );
}
